import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
// The tickable age rows shared by every age picker. Renders the options only - the caller
// owns the popover around, because a full-width dropdown and a small anchored pill
// need different positioning but the same list.
const AgeOptionList = ({ options, selected, onChange, lockedAge, maxSelected }) => {
    const isFull = maxSelected !== undefined && selected.length >= maxSelected;
    const toggle = (age) => {
        if (age === lockedAge)
            return;
        const isSelected = selected.includes(age);
        if (!isSelected && isFull)
            return;
        onChange(isSelected
            ? selected.filter(a => a !== age)
            : [...selected, age].sort((a, b) => a - b));
    };
    return (React.createElement(React.Fragment, null, options.map(o => {
        const isSelected = selected.includes(o.age);
        const isLocked = o.age === lockedAge;
        const blockedByCap = !isSelected && isFull;
        return (React.createElement("button", { type: "button", key: o.age, role: "option", "aria-selected": isSelected, "aria-disabled": isLocked || blockedByCap, className: `age-multiselect-option${isSelected ? ' selected' : ''}${isLocked || blockedByCap ? ' is-fixed' : ''}`, onClick: () => toggle(o.age), title: isLocked ? 'Always included'
                : blockedByCap ? `Up to ${maxSelected} ages`
                    : undefined },
            React.createElement("span", { className: "age-multiselect-check" }, isSelected && React.createElement(FontAwesomeIcon, { icon: faCheck })),
            React.createElement("span", null, o.displayAge),
            isLocked && React.createElement("span", { className: "age-multiselect-locked" }, "own age")));
    })));
};
export default AgeOptionList;
